import { useQuery } from '@tanstack/react-query';

import api from '@/axios';
import { GET_PURCHASE_ORDER_SYNCABLE_FIELDS_KEY } from '@/keys';
import type { PurchaseOrderSyncableField } from '@/types/core/purchase-order/purchase-order-syncable-field';

export const getPurchaseOrderSyncableFields = async (): Promise<
  PurchaseOrderSyncableField[]
> => {
  const response = await api.get<PurchaseOrderSyncableField[]>(
    '/purchase-orders/syncable-fields',
  );

  return response.data;
};

export const useGetPurchaseOrderSyncableFields = (enabled: boolean) =>
  useQuery({
    queryKey: GET_PURCHASE_ORDER_SYNCABLE_FIELDS_KEY,
    queryFn: getPurchaseOrderSyncableFields,
    enabled,
  });
